<template>
  <div class="two-factor-container m-0 px-3 py-4 content-slot-container">
    <div class="content-slot-header">
      Xác thực 2 bước (2FA)
      <div v-if="!forbidden" class="d-flex">
        <v-btn
          color="primary"
          outlined
          style="border-radius: 8px"
          class="low-letter-spacing mr-2"
          @click="showOtpClients = true"
        >
          Ứng dụng OTP
        </v-btn>
        <v-btn
          color="primary"
          depressed
          style="border-radius: 8px"
          class="low-letter-spacing"
          @click="showBulk = true"
        >
          Áp dụng theo bộ phận
        </v-btn>
      </div>
    </div>
    <div
      class="content-slot-content mx-auto w-100 white box-shadow--mod-lighter"
    >
      <div v-if="forbidden" class="pa-6 text-center semantic_error--text">
        {{ forbiddenMessage }}
      </div>
      <template v-else>
        <v-row class="m-0 align-end filter-wr">
          <v-col style="max-width: 300px" cols="auto">
            <div class="each-filter w-100">
              <p class="mb-1 filter-name neutral--text">Tìm kiếm</p>
              <v-text-field
                v-model="keyword"
                placeholder="Mã nhân viên, email, họ tên"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
                class="rounded-lg"
                @input="onKeywordInput"
                @keyup.enter="applyKeyword"
                @click:clear="onKeywordClear"
              ></v-text-field></div
          ></v-col>
          <v-col style="max-width: 220px" cols="auto">
            <div class="each-filter w-100">
              <p class="mb-1 filter-name neutral--text">Bắt buộc 2FA</p>
              <SelectAuto
                :placeholder="'Bắt buộc 2FA'"
                :onChange="onChangeRequired"
                :default-value="required"
                :options="requiredOptions"
              /></div
          ></v-col>
          <v-col style="max-width: 220px" cols="auto">
            <div class="each-filter w-100">
              <p class="mb-1 filter-name neutral--text">Telegram</p>
              <SelectAuto
                :placeholder="'Telegram'"
                :onChange="onChangeEnrolled"
                :default-value="enrolled"
                :options="enrolledOptions"
              /></div
          ></v-col>
          <v-col style="max-width: 220px" cols="auto">
            <div class="each-filter w-100">
              <p class="mb-1 filter-name neutral--text">Khóa OTP</p>
              <SelectAuto
                :placeholder="'Khóa OTP'"
                :onChange="onChangeLocked"
                :default-value="locked"
                :options="lockedOptions"
              /></div
          ></v-col>
          <v-col cols="auto" class="ml-auto">
            <div class="panigate-block px-2">
              <Pagination
                :loading="loadingSearch"
                class="mt-0"
                :pagination-sync="pagination"
                @handlePageSizeChange="pagePaginationChange"
                @handlePageChange="pagePaginationChange"
              /></div
          ></v-col>
        </v-row>
        <vue-custom-scrollbar class="scroll-area table-wrapper" v-dragscroll>
          <UserTwoFactorTable
            :list-data="listData"
            :pending-ids="pendingIds"
            :index-offset="(pagination.page - 1) * pagination.per_page"
            :onToggle="onToggle"
            :onUnlock="onUnlock"
            :isFirstLoading="isFirstLoading"
            :loadingTable="loadingSearch"
            :isSearch="isSearch"
          />
        </vue-custom-scrollbar>
      </template>
    </div>
    <DialogConfirm
      :isVisible="!!confirmState"
      :cancelAction="cancelConfirm"
      :confirmAction="submitConfirm"
      :cancelBtnText="sysLanguage.confirmDialog.cancelBtnTextNormal"
      :cancelBtnColor="'neutral_color_sub4'"
      :confirmBtnText="sysLanguage.confirmDialog.confirmBtnTextNormal"
      :title="confirmTitle"
      :message="confirmMessage"
      :rawHtml="true"
      :loadingConfirmBtn="loadingConfirm"
    />
    <DialogBulkTwoFactor
      :isVisible="showBulk"
      :loading="loadingBulk"
      :cancelAction="cancelBulk"
      :confirmAction="requestBulk"
    />
    <DialogOtpClients
      :isVisible="showOtpClients"
      :cancelAction="() => (showOtpClients = false)"
    />
  </div>
</template>

<script>
import api from "@/services"
import { mapGetters } from "vuex"
import UserTwoFactorTable from "@/components/Table/UserTwoFactorTable.vue"
import Pagination from "@/components/Layout/Pagination.vue"
import DialogConfirm from "@/components/Dialog/DialogConfirm.vue"
import DialogBulkTwoFactor from "@/components/Dialog/DialogBulkTwoFactor.vue"
import DialogOtpClients from "@/components/Dialog/DialogOtpClients.vue"
import SelectAuto from "@/components/Filter/SelectAuto.vue"
import vueCustomScrollbar from "vue-custom-scrollbar"
import "vue-custom-scrollbar/dist/vueScrollbar.css"

const FORBIDDEN_MESSAGE = "Bạn không có quyền quản trị 2FA"
// Backend rejects per_page above this with a 400
const MAX_PER_PAGE = 200
const XC_MAIN_WARNING =
  "Người dùng đã gắn Telegram sẽ phải nhập mã OTP khi đăng nhập xc-main. Chỉ bật khi xc-main đã hỗ trợ bước nhập OTP."

export default {
  components: {
    UserTwoFactorTable,
    Pagination,
    DialogConfirm,
    DialogBulkTwoFactor,
    DialogOtpClients,
    SelectAuto,
    vueCustomScrollbar,
  },
  data() {
    return {
      listData: [],
      loadingSearch: false,
      isFirstLoading: true,
      firstSync: true,
      forbidden: false,
      forbiddenMessage: FORBIDDEN_MESSAGE,
      // Filter values are strings ("1"/"0") so "0" stays truthy for SelectAuto
      required: null,
      enrolled: null,
      // "1" = chỉ hiện user đang bị khoá OTP (TTCN-1616)
      locked: null,
      // Từ khoá tìm theo mã nhân viên / email / họ tên (URL: ?q=)
      keyword: "",
      keywordTimer: null,
      requiredOptions: [
        { id: "1", name: "Bắt buộc" },
        { id: "0", name: "Không bắt buộc" },
      ],
      enrolledOptions: [
        { id: "1", name: "Đã gắn" },
        { id: "0", name: "Chưa gắn" },
      ],
      lockedOptions: [{ id: "1", name: "Đang bị khóa" }],
      pendingIds: [],
      // { type: "single", user } | { type: "bulk", departmentIds } | { type: "unlock", user }
      confirmState: null,
      loadingConfirm: false,
      showBulk: false,
      showOtpClients: false,
      loadingBulk: false,
      pagination: {
        total: 1,
        total_pages: 1,
        per_page: 15,
        page: 1,
      },
    }
  },
  computed: {
    ...mapGetters({
      sysLanguage: "sysLanguage",
    }),
    isSearch() {
      return !!(this.required || this.enrolled || this.locked || this.keyword)
    },
    confirmTitle() {
      return this.confirmState && this.confirmState.type === "unlock"
        ? "Kích hoạt lại tài khoản"
        : "Bật bắt buộc xác thực 2 bước"
    },
    confirmMessage() {
      if (!this.confirmState) {
        return ""
      }
      if (this.confirmState.type === "unlock") {
        const user = this.confirmState.user
        return `Kích hoạt lại tài khoản <b>${this.escapeHtml(
          user.name || user.code || `#${user.id}`,
        )}</b> đang bị khóa do nhập sai mã OTP? Bộ đếm số lần nhập sai sẽ về 0, liên kết Telegram giữ nguyên.`
      }
      if (this.confirmState.type === "single") {
        const user = this.confirmState.user
        return `Bật bắt buộc 2FA cho <b>${this.escapeHtml(
          user.name || user.code || `#${user.id}`,
        )}</b>?<br/><br/>${XC_MAIN_WARNING}`
      }
      return `Bật bắt buộc 2FA cho toàn bộ người dùng thuộc <b>${this.confirmState.departmentIds.length}</b> bộ phận đã chọn?<br/><br/>${XC_MAIN_WARNING}`
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    pagination: {
      deep: true,
      handler() {
        this.syncUrl()
      },
    },
  },
  mounted() {
    this.bindUrl()
    this.getListData()
  },
  beforeDestroy() {
    clearTimeout(this.keywordTimer)
  },
  methods: {
    escapeHtml(_str) {
      return String(_str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
    },
    resetToFirstPage() {
      if (this.firstSync) {
        return
      }
      this.pagination = { ...this.pagination, page: 1 }
    },
    onChangeRequired(_val) {
      this.required = _val
      this.resetToFirstPage()
    },
    onChangeEnrolled(_val) {
      this.enrolled = _val
      this.resetToFirstPage()
    },
    onChangeLocked(_val) {
      this.locked = _val
      this.resetToFirstPage()
    },
    onKeywordInput() {
      clearTimeout(this.keywordTimer)
      this.keywordTimer = setTimeout(this.applyKeyword, 400)
    },
    onKeywordClear() {
      this.keyword = ""
      this.applyKeyword()
    },
    applyKeyword() {
      clearTimeout(this.keywordTimer)
      this.keyword = (this.keyword || "").trim()
      // Đổi từ khoá luôn về trang 1 và cập nhật URL (watch $route sẽ tải lại)
      this.pagination = { ...this.pagination, page: 1 }
      this.syncUrl()
    },
    pagePaginationChange(_val) {
      this.pagination = {
        ...this.pagination,
        per_page: _val.per_page,
        page: _val.page,
      }
    },
    syncUrl() {
      const query = {
        size: this.pagination.per_page,
        page: this.pagination.page,
      }
      if (this.required) {
        query.required = this.required
      }
      if (this.enrolled) {
        query.enrolled = this.enrolled
      }
      if (this.locked) {
        query.locked = this.locked
      }
      if (this.keyword) {
        query.q = this.keyword
      }
      const path = this.$route.path
      this.$router.replace({ path, query }).catch(() => {})
    },
    bindUrl() {
      const query = this.$route.query
      if (+query.size) {
        this.pagination = { ...this.pagination, per_page: +query.size }
      }
      if (+query.page) {
        this.pagination = { ...this.pagination, page: +query.page }
      }
      if (["0", "1"].includes(query.required)) {
        this.required = query.required
      }
      if (["0", "1"].includes(query.enrolled)) {
        this.enrolled = query.enrolled
      }
      if (query.locked === "1") {
        this.locked = query.locked
      }
      if (typeof query.q === "string") {
        this.keyword = query.q
      }
    },
    async getListData() {
      this.loadingSearch = true
      const query = this.$route.query
      // The 2FA API names page size `per_page`; the URL keeps `size` like other screens
      const payload = {
        per_page: Math.min(
          +query.size || this.pagination.per_page,
          MAX_PER_PAGE,
        ),
        page: +query.page || 1,
      }
      if (["0", "1"].includes(query.required)) {
        payload.required = query.required
      }
      if (["0", "1"].includes(query.enrolled)) {
        payload.enrolled = query.enrolled
      }
      if (query.locked === "1") {
        payload.locked = 1
      }
      if (query.q) {
        payload.q = query.q
      }
      const res = await api.twoFactor.getListTwoFactorUsers(payload)
      this.isFirstLoading = false
      this.loadingSearch = false
      this.firstSync = false
      if (!res) {
        this.$store.commit(
          "toast/getError",
          "Không tải được danh sách người dùng",
        )
        return
      }
      try {
        if (res.status === 403) {
          this.forbidden = true
          this.listData = []
          return
        }
        if (res.status && res.status >= 400) {
          this.$store.commit("toast/getError", res.data.message)
          return
        }
        this.forbidden = false
        const dataObj = res.data.data
        this.listData = dataObj.users
        const pg = dataObj.meta.pagination
        // API trả meta phân trang của fractal: `total_pages` (không có `last_page`)
        this.pagination = {
          total: pg.total,
          total_pages: pg.total_pages || pg.last_page || 1,
          per_page: pg.per_page,
          page: pg.current_page,
        }
      } catch (error) {
        this.$store.commit("toast/getError", `${error}`)
      }
    },
    errorMessage(res) {
      if (res.status === 403) {
        return FORBIDDEN_MESSAGE
      }
      return (res.data && res.data.message) || "Có lỗi xảy ra"
    },
    updateDataLocal(_user) {
      const index = this.listData.findIndex((o) => o.id === _user.id)
      if (index !== -1) {
        this.listData.splice(index, 1, { ...this.listData[index], ..._user })
      }
    },
    onToggle(_user) {
      if (this.pendingIds.includes(_user.id)) {
        return
      }
      const target = !_user.two_factor_required
      if (target) {
        this.confirmState = { type: "single", user: _user }
        return
      }
      this.setRequired(_user, false)
    },
    async setRequired(_user, _required) {
      this.pendingIds.push(_user.id)
      const res = await api.twoFactor.setTwoFactorRequired(_user.id, _required)
      this.pendingIds = this.pendingIds.filter((id) => id !== _user.id)
      if (!res) {
        this.$store.commit("toast/getError", "Không cập nhật được 2FA")
        return false
      }
      try {
        if (res.status && res.status >= 400) {
          this.$store.commit("toast/getError", this.errorMessage(res))
          return false
        }
        const user = res.data.data.user
        this.updateDataLocal(user)
        this.$store.commit(
          "toast/getSuccess",
          user.two_factor_required
            ? "Đã bật bắt buộc 2FA"
            : "Đã tắt bắt buộc 2FA",
        )
        return true
      } catch (error) {
        this.$store.commit("toast/getError", `${error}`)
        return false
      }
    },
    onUnlock(_user) {
      if (this.pendingIds.includes(_user.id)) {
        return
      }
      this.confirmState = { type: "unlock", user: _user }
    },
    async unlockUser(_user) {
      this.pendingIds.push(_user.id)
      const res = await api.twoFactor.unlockTwoFactorUser(_user.id)
      this.pendingIds = this.pendingIds.filter((id) => id !== _user.id)
      if (!res || (res.status && res.status >= 400)) {
        this.$store.commit(
          "toast/getError",
          res ? this.errorMessage(res) : "Không kích hoạt lại được tài khoản",
        )
        return
      }
      this.updateDataLocal(res.data.data.user)
      this.$store.commit("toast/getSuccess", "Đã kích hoạt lại tài khoản")
    },
    requestBulk(_payload) {
      if (_payload.required) {
        this.confirmState = {
          type: "bulk",
          departmentIds: _payload.departmentIds,
        }
        return
      }
      this.submitBulk(false, _payload.departmentIds)
    },
    async submitBulk(_required, _departmentIds) {
      this.loadingBulk = true
      const res = await api.twoFactor.bulkSetTwoFactorRequired({
        required: _required,
        departmentIds: _departmentIds,
      })
      this.loadingBulk = false
      if (!res) {
        this.$store.commit("toast/getError", "Không cập nhật được 2FA")
        return
      }
      try {
        if (res.status && res.status >= 400) {
          this.$store.commit("toast/getError", this.errorMessage(res))
          return
        }
        // `affected` counts every matched user, including ones already at this value
        this.$store.commit(
          "toast/getSuccess",
          `Đã áp dụng cho ${res.data.data.affected} người dùng`,
        )
        this.showBulk = false
        this.getListData()
      } catch (error) {
        this.$store.commit("toast/getError", `${error}`)
      }
    },
    cancelBulk() {
      this.showBulk = false
    },
    cancelConfirm() {
      if (this.loadingConfirm) {
        return
      }
      this.confirmState = null
    },
    async submitConfirm() {
      const state = this.confirmState
      if (!state) {
        return
      }
      this.loadingConfirm = true
      if (state.type === "unlock") {
        await this.unlockUser(state.user)
      } else if (state.type === "single") {
        await this.setRequired(state.user, true)
      } else {
        await this.submitBulk(true, state.departmentIds)
      }
      this.loadingConfirm = false
      this.confirmState = null
    },
  },
}
</script>

<style lang="scss" scoped>
.two-factor-container {
  .filter-wr {
    min-height: 100px;
  }
  .table-wrapper {
    position: relative;
    height: calc(100% - 100px);
    padding-bottom: 70px;
    overflow-x: scroll;
    overflow-y: scroll;
  }
}
</style>
